export const MAX_LENGTHS = {
    STREET: 100,
    CITY: 50,
    PROVINCE: 20,
    POSTAL_CODE: 10,
    COUNTRY: 30,
    EMAIL: 50,
    PEC: 50,
    PHONE_NUMBER_A: 20,
    PHONE_NUMBER_B: 20,
    WEBSITE: 100,
};
